<button
  *transloco="let t"
  #switchButton
  class="cx-icon-button-md"
  mat-icon-button
  (click)="onSwitchButtonClicked(); switchButton._elementRef.nativeElement.blur()"
  [matTooltip]="t(userConfigsFacade.isInternalViewSignal() ? 'Switch to customer view' : 'Switch to service view')"
  data-cy="switch-button-button">
  <mat-icon svgIcon="swap_horiz"/>
</button>
